// extracted by mini-css-extract-plugin
module.exports = {"box":"Background_box__2d3rC","isLoggin":"Background_isLoggin__3t42u","ellipseBlue":"Background_ellipseBlue__3y9x6","ellipsePink":"Background_ellipsePink__303hS"};